import Vue from "vue";
import VueRouter from "vue-router";
import { ADMIN_BASE_PATH, isAdminRoute } from "@/constants/admin";
import { trackOfficialPageview } from "@/utils/baiduHm";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/official/Layout.vue"),
    children: [
      {
        path: "",
        redirect: "/home",
      },
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/official/Home.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "about",
        name: "About",
        component: () => import("@/views/official/About.vue"),
        meta: {
          title: "关于我们",
        },
      },
      {
        path: "news",
        name: "News",
        component: () => import("@/views/official/News.vue"),
        meta: {
          title: "资讯中心",
        },
      },
      {
        path: "join",
        name: "Join",
        component: () => import("@/views/official/Join.vue"),
        meta: {
          title: "加入我们",
        },
      },
      {
        path: "phoneUs",
        name: "PhoneUs",
        component: () => import("@/views/official/PhoneUs.vue"),
        meta: {
          title: "联系我们",
        },
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/register",
    component: () => import("@/views/login/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: ADMIN_BASE_PATH,
    name: "Admin",
    component: () => import("@/views/admin/AdminLayout.vue"),
    meta: {
      title: "后台首页",
    },
    children: [
      {
        path: "",
        redirect: "index",
      },
      {
        path: "index",
        name: "AdminIndex",
        component: () => import("@/views/admin/Dashboard.vue"),
        meta: {
          title: "仪表盘",
        },
      },
      {
        path: "user",
        name: "User",
        component: () => import("@/views/admin/userList.vue"),
        meta: {
          title: "用户列表",
        },
      },
      {
        path: "site",
        name: "SiteConfig",
        component: () => import("@/views/admin/SiteConfig.vue"),
        meta: {
          title: "相关配置",
        },
      },
      {
        path: "content",
        redirect: "content/document",
      },
      {
        path: "content/category",
        name: "CategoryManage",
        component: () => import("@/views/admin/CategoryManage.vue"),
        meta: {
          title: "栏目管理",
        },
      },
      {
        path: "content/document",
        name: "ContentManage",
        component: () => import("@/views/admin/ContentManage.vue"),
        meta: {
          title: "文档管理",
        },
      },
      {
        path: "position",
        name: "PositionManage",
        component: () => import("@/views/admin/Info.vue"),
        meta: {
          title: "职位管理",
        },
      },
      {
        path: "resume",
        name: "ResumeList",
        component: () => import("@/views/admin/ResumeList.vue"),
        meta: {
          title: "简历列表",
        },
      },
      {
        path: "message",
        name: "MessageManage",
        component: () => import("@/views/admin/MessageManage.vue"),
        meta: {
          title: "留言列表",
        },
      },
      {
        path: "qrcode",
        name: "QrcodeManage",
        component: () => import("@/views/admin/QrcodeManage.vue"),
        meta: {
          title: "渠道列表",
        },
      },
      {
        path: "logs",
        name: "OperationLog",
        component: () => import("@/views/admin/OperationLog.vue"),
        meta: {
          title: "日志列表",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  if (isAdminRoute(to.path)) {
    const token = localStorage.getItem('token');
    if (!token) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

// 官网前台百度统计（管理端 / 登录 / 注册不上报）
router.afterEach((to) => {
  trackOfficialPageview(to.fullPath);
});

export default router;

export function resetRouter() {
  router.push({ path: "/login" });
}
